/*
 * Authors: mariushirjanu
 * Created: 18/05/2018
 */

import { Injectable } from '@angular/core';

import { ICodeValue, ICompany, ICompanyCountry, IContact, ICountry, IWebshop } from '../../../../type_definitions/datatypes';
import { HttpDataService } from '../../../shared/http/http-data.service';

@Injectable()
export class WebshopRoleDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public webshop(webshopId:number):Promise<IWebshop> {
    return this.httpDataService.doGET(
      `rest/webshoproles/${webshopId}`,
      undefined,
      undefined,
      'Error loading roles'
    );
  }

  public webshopRolesTypes():Promise<ICodeValue[]> {
    return this.httpDataService.doGET(
      'rest/webshoproles/types',
      undefined,
      undefined,
      'Error loading types'
    );
  }

  public webshopRoles(webshopId:number, roleType:string):Promise<string[]> {
    return this.httpDataService.doGET(
      `rest/webshoproles/${webshopId}/roles`,
      { roleType },
      undefined,
      'Error loading webshops roles'
    );
  }

  public webshopsRolesUsers(companyId:number):Promise<IContact[]> {
    return this.httpDataService.doGET(
      'rest/webshoproles/users',
      {
        companyId
      },
      undefined,
      'Error loading contacts'
    );
  }

  public webshopRolesCountries(webshopId:number):Promise<ICountry[]> {
    return this.httpDataService.doGET(
      `rest/webshoproles/${webshopId}/countries`,
      undefined,
      undefined,
      'Error loading countries'
    );
  }

  public webshopRolesCompanies(webshopId:number, countryId:number, roleType:string):Promise<ICompany[]> {
    return this.httpDataService.doGET(
      `rest/webshoproles/${webshopId}/companies`,
      {
        countryId,
        roleType
      },
      undefined,
      'Error loading companies'
    );
  }

  public getWebshopRolesCompanyCountries(webshopId:number, countryId:number, roleType:string):Promise<ICompanyCountry[]> {
    return this.httpDataService.doGET(
      `rest/webshoproles/${webshopId}/companyCountries`,
      {
        countryId,
        roleType
      },
      undefined,
      'Error loading companies'
    );
  }
}